<template>
	<div class="continue-updating-container d-flex py-3 px-5 gap-3 rounded-4 bg-neutral-25 border-xs">
		<Cover
			class="rounded-2 align-self-center z-3"
			:src="coverImage"
			width="56px"
			height="56px"
			rounded-class="rounded-2"
			display-inner-border
			preview-on-server
		/>
		<div class="d-flex flex-column">
			<p class="text-title-s text-neutral-900">{{ $t('web.home.banner.title') }}</p>
			<h3 class="text-title-l text-neutral-900">{{ trip.name }}</h3>
			<PButton
				type="outlined"
				color="neutral"
				size="sm"
				class="mt-2"
				style="width: fit-content"
				@click="() => goToTrip(trip.id!)"
			>
				{{ $t('web.home.banner.button') }}
			</PButton>
		</div>
		<Icon
			class="cursor-pointer text-neutral-800"
			icon="close"
			:stroke-width="2"
			@click="$emit('close')"
		/>
	</div>
</template>
<script setup lang="ts">
	import { Itinerary2 } from '~/models/Itinerary'
	import { TripNavigation } from '~/services/navigation/trip'
	import { computed } from 'vue'

	interface Props {
		trip: Itinerary2
	}

	const props = defineProps<Props>()
	defineEmits(['close'])

	const coverImage = computed((): string => {
		return props.trip.cover || ''
	})

	const goToTrip = (tripId: string) => {
		TripNavigation.toTripDashboard(tripId)
	}
</script>
<style lang="scss" scoped>
	.continue-updating-container {
		backdrop-filter: blur(40px);
		background: #f6f6f64d;
		border-color: #ffffff33;
	}
</style>
